var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.provider === 'stripe')?_c('stripe-payment',{attrs:{"watchSubmit":_vm.watchSubmit,"stripePublishableKey":_vm.paymentKey},on:{"input":function($event){return _vm.$emit('input', $event)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }